import { Grid, Typography, useMediaQuery, Collapse } from '@material-ui/core';
//import { OptionBar } from '@solteq-react/components';
import { get as _get } from 'lodash';
import React, { useState, useMemo } from 'react';
import { Paper } from '@material-ui/core';
import { TrafiLayout, WithTrafiLayout } from './TrafiLayout';
import SearchInput from './SearchInput';
import { QueryTypeDropdown, VehicleTypeDropdown } from './Dropdowns';
import { TextButton } from './solteq-react/forms/Buttons';
import { QueryPreviewPanel } from './QueryPreviews';
import { withRouter } from 'react-router-dom';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';
import { connect } from 'react-redux';
import { queryThunk } from '../redux/registryThunks';
import LoadingIndicator from './LoadingIndicator';
import { QueryResultPanels } from './QueryResult';
import AlertNotification from './AlertNotification';
import ServiceBreakNotification from './ServiceBreakNotification';

const TrafiSearchableLayout = connect(
    (state) => ({
        formValues: _get(state, withReducerName(reduxStateMap.FORM_VALUES), {})
    }),
    (dispatch) => ({
        executeQuery: () => dispatch(queryThunk())
    })
)(
    withRouter(({ renderContent, isJumbotronBig, executeQuery, history, formValues }) => {
        const isBigTitleUsed = useMediaQuery('(min-width:600px)');
        const isAllSingleRow = useMediaQuery('(min-width:1044px)');
        const [alertMessage, setAlertMessage] = useState('');
        return (
            <Grid container style={{ flexGrow: 1, flexWrap: 'nowrap' }} direction="column">
                <Grid item container justifyContent="center" direction="column">
                    <Collapse in={isJumbotronBig} classes="MuiGrid-root MuiGrid-item MuiGrid-container" collapsedHeight="20px">
                        {isBigTitleUsed && <ServiceBreakNotification />}
                        <Grid item container justifyContent="center" style={{ minHeight: isBigTitleUsed ? '300px' : '100px' }}>
                            <Grid item style={{ margin: 'auto' }}>
                                <Typography variant={isBigTitleUsed ? 'h3' : 'h5'} style={{ color: 'white', fontWeight: '600' }}>
                                    Ajoneuvokysely
                                </Typography>
                            </Grid>
                        </Grid>
                    </Collapse>
                </Grid>
                <Grid item container style={{ background: '#fafafa', flexGrow: 1, marginTop: '50px' }} alignItems="center" direction="column">
                    <Grid
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        style={{
                            width: '95%',
                            marginLeft: '10px',
                            marginRight: '10px',
                            maxWidth: '1440px',
                            marginTop: '-50px'
                        }}
                    >
                        <Grid item container>
                            <Paper
                                elevation={5}
                                style={{
                                    padding: '20px',
                                    width: 'inherit',
                                    minWidth: isAllSingleRow ? 'calc(1024px - 40px)' : 0
                                }}
                            >
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();

                                        // Validate input
                                        let errorMsgs = [];
                                        if (!formValues.searchTerm || formValues.searchTerm.length === 0) {
                                            errorMsgs.push('Syötä rekisteritunnus tai VIN.');
                                        }
                                        if (!formValues.queryType) {
                                            errorMsgs.push('Valitse kyselylaji.');
                                        }
                                        if (!formValues.vehicleType) {
                                            // && !!formValues.queryType && !!formValues.searchTerm && formValues.searchTerm.length > 4)) {
                                            errorMsgs.push('Valitse ajoneuvoluokka.');
                                        }
                                        if (errorMsgs.length > 0) {
                                            setAlertMessage(errorMsgs.join(' '));
                                            return;
                                        }

                                        setAlertMessage(undefined);

                                        if (isJumbotronBig) {
                                            history.push('/Search');
                                        }

                                        // Clear all selections
                                        if (window.getSelection) {
                                            window.getSelection().removeAllRanges();
                                        } else if (document.selection) {
                                            document.selection.empty();
                                        }

                                        executeQuery();
                                    }}
                                >
                                    <Grid container direction="column">
                                        <Grid item style={{ boxSizing: 'unset' }}>
                                            <AlertNotification
                                                alertMessage={alertMessage}
                                                handleClose={() => setAlertMessage(undefined)}
                                                styles={{ marginBottom: '20px' }}
                                            />
                                        </Grid>
                                        <Grid container direction="row" alignItems="center">
                                            <Grid item xs={isAllSingleRow ? 4 : 12}>
                                                <SearchInput />
                                            </Grid>
                                            <Grid
                                                item
                                                style={{ paddingLeft: isAllSingleRow ? '20px' : 0, marginTop: !isAllSingleRow && '20px' }}
                                                xs={isAllSingleRow ? 3 : 6}
                                            >
                                                <QueryTypeDropdown />
                                            </Grid>
                                            <Grid item style={{ paddingLeft: '20px', marginTop: !isAllSingleRow && '20px' }} xs={isAllSingleRow ? 3 : 6}>
                                                <VehicleTypeDropdown />
                                            </Grid>
                                            <Grid
                                                item
                                                style={{ paddingLeft: isAllSingleRow ? '20px' : 0, marginTop: !isAllSingleRow && '20px' }}
                                                xs={isAllSingleRow ? 2 : 12}
                                            >
                                                <TextButton variant="contained" color="secondary" fullWidth style={{ height: '55px', minWidth: 0 }} type="submit">
                                                    Hae
                                                </TextButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Paper>
                        </Grid>
                        {renderContent({ isBigTitleUsed })}
                    </Grid>
                </Grid>
            </Grid>
        );
    })
);

const WithTrafiSearchableLayout = (Wrapped, isJumbotronBig, props) => <TrafiSearchableLayout isJumbotronBig={isJumbotronBig} Wrapped={Wrapped} wrappedProps={props} />;

// Preview

const BasePreview = ({ configuration, isBigTitleUsed }) => {
    return (
        <Grid item container justifyContent="center" direction="row" style={{ marginTop: '16px' }} spacing={4}>
            {configuration.Previews.map((p, i) => (
                <Grid item md={4} sm={12} xs={12} key={i}>
                    <QueryPreviewPanel preview={p} isBigTitleUsed={isBigTitleUsed} />
                </Grid>
            ))}
        </Grid>
    );
};

const SearchablePreview = WithTrafiSearchableLayout(BasePreview, true);
export const Preview = WithTrafiLayout(SearchablePreview, true);

// Search

const BaseSearch2 = connect((state) => ({
    data: _get(state, withReducerName(reduxStateMap.DATA), null),
    formValues: _get(state, withReducerName(reduxStateMap.FORM_VALUES), {})
}))(({ configuration, isBigTitleUsed, data, formValues }) => {
    if (!data) {
        return <LoadingIndicator />;
    }

    const searchTerm = formValues[reduxStateMap.SEARCH_TERM];
    const queryName = data.QueryResult && data.QueryResult.Name;
    const title = useMemo(() => `${queryName} hakutermillä ${searchTerm}`, [queryName, searchTerm]);
    const errorMsg = !data.IsSuccess && data.ErrorMessage;
    const [dataMsg, setDataMsg] = useState(data.QueryResult?.HasRestrictions && 'Ajoneuvolla rajoitustietoja');
    const addressSource = 'Lähde: Liikenne- ja viestintävirasto Traficom, liikenneasioiden rekisteri.';
    return (
        <Grid item container justifyContent="left" direction="column">
            <Grid item container direction="row" justifyContent="center" style={{ marginTop: '55px', marginBottom: '16px' }}>
                <Grid item>
                    <Typography variant={isBigTitleUsed ? 'h5' : 'h6'} style={{ color: 'rgba(20, 24, 30, 0.3)', fontWeight: '300' }}>
                        {addressSource}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant={isBigTitleUsed ? 'h5' : 'h6'} style={{ color: 'rgba(20, 24, 30, 0.3)', fontWeight: '600' }}>
                        {errorMsg || title}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item style={{ boxSizing: 'unset', position: 'relative', height: 0, top: '-8px' }}>
                <AlertNotification alertMessage={dataMsg} handleClose={() => setDataMsg(undefined)} />
            </Grid>
            {data.QueryResult && data.QueryResult.Regions && <QueryResultPanels queryResult={data.QueryResult} isBigTitleUsed={isBigTitleUsed} />}
        </Grid>
    );
});
const SearchableSearch2 = WithTrafiSearchableLayout(BaseSearch2, false);
export const Search2 = WithTrafiLayout(SearchableSearch2, true);

const BaseSearch = connect((state) => ({
    data: _get(state, withReducerName(reduxStateMap.DATA), null),
    formValues: _get(state, withReducerName(reduxStateMap.FORM_VALUES), {})
}))(({ configuration, isBigTitleUsed, data, formValues }) => {
    if (!data) {
        return <LoadingIndicator />;
    }

    const searchTerm = formValues[reduxStateMap.SEARCH_TERM];
    const queryName = data.QueryResult && data.QueryResult.Name;
    const title = useMemo(() => `${queryName} hakutermillä ${searchTerm}`, [queryName, searchTerm]);
    const errorMsg = !data.IsSuccess && data.ErrorMessage;
    const [dataMsg, setDataMsg] = useState(data.QueryResult?.HasRestrictions && 'Ajoneuvolla rajoitustietoja');
    const addressSource = 'Lähde: Liikenne- ja viestintävirasto Traficom, liikenneasioiden rekisteri.';

    return (
        <Grid item container justifyContent="center" direction="column">
            <Grid item container direction="row" justifyContent="left" style={{ marginTop: '10px', marginBottom: '16px' }}>
                <Grid item>
                    <Typography variant={isBigTitleUsed ? 'h7' : 'h8'} style={{ color: 'rgba(20, 24, 30, 0.6)', fontWeight: '200' }}>
                        {addressSource}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item container direction="row" justifyContent="center" style={{ marginTop: '35px', marginBottom: '16px' }}>
                <Grid item>
                    <Typography variant={isBigTitleUsed ? 'h5' : 'h6'} style={{ color: 'rgba(20, 24, 30, 0.3)', fontWeight: '600' }}>
                        {errorMsg || title}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item style={{ boxSizing: 'unset', position: 'relative', height: 0, top: '-8px' }}>
                <AlertNotification alertMessage={dataMsg} handleClose={() => setDataMsg(undefined)} />
            </Grid>
            {data.QueryResult && data.QueryResult.Regions && <QueryResultPanels queryResult={data.QueryResult} isBigTitleUsed={isBigTitleUsed} />}
        </Grid>
    );
});
const SearchableSearch = WithTrafiSearchableLayout(BaseSearch, false);
export const Search = WithTrafiLayout(SearchableSearch, true);

// Home

export const Home = withRouter(({ match }) => {
    const { params } = match;
    const page = params[0];
    let props =
        page === 'Preview'
            ? {
                  isJumbotronBig: true,
                  Component: BasePreview
              }
            : page === 'Search'
            ? {
                  isJumbotronBig: false,
                  Component: BaseSearch
              }
            : (() => {
                  throw new Error('Incorrect route');
              })();
    const { Component } = props;
    return (
        <TrafiLayout
            isLogon={true}
            renderContent={(props1) => <TrafiSearchableLayout isJumbotronBig={props.isJumbotronBig} renderContent={(props2) => <Component {...props2} {...props1} />} />}
        />
    );
});
